/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "../Helper";
import { useStore } from "@/store";
import { BotStore } from "@/store/constants";

let chatbotId;
export const getChatbotId = (): string | undefined => {
  const store = useStore();
  chatbotId = store.getters[BotStore.Getters.GET_ID];
  return chatbotId;
};

/**
 * Adds the specified language
 * @param language as two-letter code (e.g. DE or EN)
 */
export const addLanguage = async (
  language: string,
  translateTrainingsData: boolean,
  translateContent: boolean
) => {
  if (!chatbotId) getChatbotId();
  await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/languages",
    "POST",
    {},
    {
      language,
      translate_trainings_data: translateTrainingsData || false,
      translate_content: translateContent || false,
    }
  );
};

/**
 * Deletes the specified language
 * @param language as two-letter code (e.g. DE or EN)
 */
export const deleteLanguage = async (language: string) => {
  if (!chatbotId) getChatbotId();
  await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" +
      chatbotId +
      "/languages/" +
      language,
    "DELETE"
  );
};
